"use client";
import { ProductFilter } from "@lib/data/products";
import { Divider } from "@medusajs/ui";
import Accordion from "@modules/products/components/product-tabs/accordion";
import { usePathname } from "next/navigation";
import FilterNameCheckBox from "./filter-name-checkbox";
import FilterRange from "./filter-range";
import SortProducts, { SortOptions } from "./sort-products";

const getFilterLabel = (key: string) => {
  switch (key) {
    case "categories":
      return "Danh mục";
    case "brands":
      return "Thương hiệu";
    case "collections":
      return "Bộ sưu tập";
    default:
      return key;
  }
};

function RenderFilterCheckbox({
  response,
  sortBy,
}: {
  response: Record<string, ProductFilter[]>;
  sortBy: SortOptions;
}) {
  const newResponse = { ...response };

  const pathname = usePathname();

  const shouldHideCategories = pathname.includes("/categories/");
  const shouldHideCollections = pathname.includes("/collections/");

  return (
    <div className="flex small:flex-col gap-12 lg:py-4 lg:mb-8 small:px-0 lg:pl-6 small:min-w-[250px] w-full overflow-y-scroll h-screen scrollbar-hide">
      <div className="w-full">
        <Accordion
          type="multiple"
          defaultValue={["Sắp xếp theo", "Giá (đ)", ...Object.keys(newResponse).map(getFilterLabel)]}
        >
          {/* Sort */}
          <Accordion.Item title="Sắp xếp theo" value="Sắp xếp theo" headingSize="large" customTrigger>
            <SortProducts sortBy={sortBy} />
          </Accordion.Item>

          {/* Price range */}
          <Accordion.Item title="Giá (đ)" value="Giá (đ)" headingSize="large" customTrigger>
            <FilterRange />
          </Accordion.Item>

          {/* Dynamic Filters */}
          {Object.entries(newResponse)
            .filter(([key, value]) => {
              if (key === "categories" && shouldHideCategories) return false;
              if (key === "collections" && shouldHideCollections) return false;
              if (!(value as ProductFilter[])?.length) return false;
              return true;
            })
            .map(([key, value]) => {
              return (
                <div key={`${key}-${value.map((v) => v.id).join(",")}`}>
                  <Divider className="my-3" />
                  <div className="font-[600]">{getFilterLabel(key)}</div>
                  <FilterNameCheckBox value={value} filterKey={key} />
                </div>
              );
            })}
        </Accordion>
      </div>
    </div>
  );
}

export default RenderFilterCheckbox;
